module.exports = __webpack_public_path__ + "fonts/opensans-semibold.fb66aecf.woff";